module.exports = __webpack_public_path__ + "img/Vector.150a5660.svg";